// extracted by mini-css-extract-plugin
export default {"main":"orders__main__a_09yE"};